













import { Component, Prop, Vue } from 'vue-property-decorator';
import { FilterSelectBlock, FilterBottonsBlock } from './components';

@Component({
  components: {
    FilterSelectBlock,
    FilterBottonsBlock,
  },
})
export default class CalendarFilter extends Vue {
  @Prop({ type: String, default: '1' })
  readonly monthValue!: string;

  @Prop({ type: String, default: '2020' })
  readonly monthYear!: string;

  fillteredOut(value: string) {
    this.$emit('typeChange', value);
  }

  monthChange(value: number) {
    this.$emit('monthChange', value);
  }

  yearChange(value: number) {
    this.$emit('yearChange', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/CalendarFilter.vue